import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  subtitle: {
    fontFamily: "open-sans-bold",
    fontSize: 20,
    textAlign: "center",
    color: "#e2b497",
  },
  subtitleContainer: {
    padding: 6,
    borderBottomColor: "#e2b497",
    borderBottomWidth: 2,
    margin: 4,
    marginHorizontal: 12,
    marginVertical: 4,
  },
  listItem: {
    borderRadius: 6,
    paddingHorizontal: 8,
    paddingVertical: 4,
    marginVertical: 4,
    marginHorizontal: 12,
    backgroundColor: "#e2b497",
  },
  itemText: {
    fontFamily: "open-sans",
    fontSize: 16,
    color: "#351401",
    textAlign: "center",
  },
});

export default styles;
